import React, { useState } from "react";
import ProductModal from "../../../../components/ProductModal";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import styles from "./Row.module.sass";
import Modal from "../../../../components/Modal";
import Confirm from "../../../../components/Confirm";
import Actions from "../../../../components/Actions";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import { UseApi } from "../../../../hooks/use-api";
import {
	DeleteCollection,
	UpdateCollection,
} from "../../../../Services/lib/nft";
import { GetStatus } from "./utils";
import { useUser } from "../../../../context";
import Icon from "../../../../components/Icon";

const Row = ({ item, set_edit, getCollection_ }) => {
	const { locale } = useUser();
	const [{ isLoading: isLoadingD }, delete_] = UseApi({
		service: DeleteCollection,
	});
	const [{ isLoading: LoadingHide }, hide] = UseApi({
		service: UpdateCollection,
	});
	const [isHidden, setHidden] = useState(item.is_hide);

	const HideController = async () => {
		const res = await hide({
			_id: item._id,
			is_hide: !isHidden,
		});
		if (res) {
			setHidden((p) => !p);
			ToastEmitter({
				type: "success",
				msg: `Product successfully ${!isHidden ? "hided" : "unhided"}.`,
			});
		}
	};
	const {
		isOpen: confirmV,
		onClose: confirmC,
		onOpen: confirmO,
	} = UseDisclosure();

	const actions =
		item.status === "DRAFT"
			? [
					{
						title: "Delete collection",
						icon: "trash",
						isLoading: isLoadingD,
						action: confirmO,
					},
			  ]
			: [
					{
						isLoading: LoadingHide,
						title: isHidden
							? "Unhide collection"
							: "Hide collection",
						svgImage: isHidden ? "eye" : "hideEye",
						action: () => HideController(),
					},
					{
						title: "Delete collection",
						icon: "trash",
						isLoading: isLoadingD,
						action: confirmO,
					},
			  ];
	const start =
		item.startDate && !isNaN(new Date(item.startDate).getTime())
			? new Date(item.startDate)
			: "";
	const end =
		item.endDate && !isNaN(new Date(item.endDate).getTime())
			? new Date(item.endDate)
			: "";
	const Status =
		item.status === "DRAFT" ? "DRAFT" : GetStatus(item, start, end);
	const { isOpen, onClose, onOpen } = UseDisclosure();

	const onConfirm = async () => {
		const res = await delete_(item._id);
		if (res) {
			ToastEmitter({
				msg: "Collection successfully deleted",
				type: "success",
			});
			getCollection_();
		}
	};

	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}>
					<div
						onClick={() => {
							set_edit(item);
						}}
						className={styles.name}
					>
						<div className={styles.img}>
							<img src={item.image} alt={item.name} />
						</div>

						<div className={styles.icon}>
							{isHidden && (
								<Icon svgImage="hideEye" reicon="red" />
							)}
						</div>
						<div>{item.name}</div>
					</div>
				</div>
				{/* <div className={styles.col}>
					<div>
						{start === "" ? "- - - - - - -" : start.toLocaleDateString()}
					</div>
					<div>
						{start === "" ? "- - - - - - -" : start.toLocaleTimeString()}
					</div>
				</div>
				<div className={styles.col}>
					<div>{end === "" ? "- - - - - - -" : end.toLocaleDateString()}</div>
					<div>{end === "" ? "- - - - - - -" : end.toLocaleTimeString()}</div>
				</div> */}
				<div className={styles.col}>{item.nftTemplates.length}</div>
				{/* <div className={styles.col}>
					<div>{buttons[Status].text}</div>
				</div> */}
				<div className={styles.col}>
					<Actions
						classActionsHead={styles.actionsHead}
						items={actions}
					/>
				</div>
			</div>
			<ProductModal visible={isOpen} onClose={onClose} data={item} nfts />
			<Modal visible={confirmV} onClose={confirmC}>
				<Confirm
					title="This action will delete collection"
					onCancel={confirmC}
					onConfirm={onConfirm}
					isLoading={false}
				/>
			</Modal>
		</>
	);
};

export default Row;
